/**
 * Kredi kartı numarasını BIN numarası formatına dönüştürür
 * @param cardNumber Kredi kartı numarası
 * @returns 8 haneli BIN numarası
 */

const formatCardBinNumber = (cardNumber?: string): string => {
  if (!cardNumber) return '';
  return cardNumber.slice(0, 8).replace(/\D/g, '').padEnd(8, '0');
};

export default formatCardBinNumber;
